import React from 'react';
import PropTypes from 'prop-types';

import {labels} from '../../../../../../util/utils';
import {CUSTOM_COLUMN, CUSTOM_COLUMN_ATTRIBUTE} from '../DCAForm/utils/constants';

import {IconoirProhibition} from '@ey-xd/motif-icon';

import RadioButtonGroup from '../../../../../CoreWrappers/RadioButtonGroup';
import IconMessage from '../../../../../CoreWrappers/IconMessage';
import Select from '../../../../../CoreWrappers/Select';
import HrAlt from '../../../../../Common/Hr/HrAlt';

const CustomAttributesPanel = ({
	values,
	errors,
	handleChange,
	handleSubmit,
	handleReset,
	isFormValid,
	customColumns
}) => {
	const renderEmpty = () => <IconMessage title={labels.noCustomColumns} icon={IconoirProhibition} />;

	const renderColumnDropdown = () => {
		const id = CUSTOM_COLUMN;
		const options = customColumns.map((column) => ({id: `${column.id}`, label: `${column.name}`}));

		const props = {
			id,
			label: labels.customColumns,
			value: values[id],
			options,
			onChange: (column) => handleChange(id, column, {[CUSTOM_COLUMN_ATTRIBUTE]: null}),
			topfix: true
		};

		if (errors[id]) props.errorMessage = errors[id]?.message;

		return <Select {...props} />;
	};

	const renderRadioGroup = () => {
		if (values[CUSTOM_COLUMN] === null) return false;

		const id = CUSTOM_COLUMN_ATTRIBUTE;

		const column = customColumns?.find((col) => col.id === values[CUSTOM_COLUMN]);
		const options = column?.options?.map(({id, option: label}) => ({id, label}));

		const props = {
			id,
			name: id,
			options,
			value: values[id],
			onChange: (value) => {
				if (values[id] !== null && value.id === values[id]) handleChange(id, null);
				else handleChange(id, value);
			}
		};

		return <RadioButtonGroup {...props} />;
	};

	const renderPanel = () => {
		return (
			<>
				{renderColumnDropdown()}
				{values[CUSTOM_COLUMN] !== null && <HrAlt />}
				{renderRadioGroup()}
			</>
		);
	};

	return (
		<>
			{!customColumns.length > 0 && renderEmpty()}
			{customColumns.length > 0 && renderPanel()}
		</>
	);
};

CustomAttributesPanel.propTypes = {};

export default CustomAttributesPanel;
